export default __webpack_public_path__ + "static/media/code_jdxcx.ed9e0c3f.png";